import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Services
import { ABTestService } from './services/abtest.service';
import { AemService } from './services/aem.service';
import { CartService } from './services/cart.service';
import { CommonService } from './services/common.service';
import { ConfigService } from './services/config.service';
import { DatalayerService } from './services/datalayer.service';
import { UtilService } from './services/util.service';
import { UserInfoService } from './services/user-info.service';
import { EnviormentConfig } from './wcax-env-config';
import { ProductCouponService } from './services/product-coupon.service';
import { OfferDetailService } from './services/offer-detail.service';
import { CouponListService } from './services/coupon-list.service';
import { CartV2Service } from './services/cart-v2.service';
import { ProductUtilService }  from './services/product-util.service';
import { AppConfigService } from './services/app.config.service';
import { ArService } from './services/ar.service';
import { BoxtopService } from './services/boxtop.service';
import { ProductFilterService } from './services/product-filter.service';
import {IntersectionObserverService} from './services/intersection-observer.service';
import { SortAlV1Service } from './services/sort-al-v1.service'
import { DatasScrollService } from './services/scroll-detection.service'
import { LoaderService } from './services/loading-spinner.service'
import { J4uV1Service } from './services/j4u-v1.service';
import { LoyaltyCarouselService } from './services/loyalty-carousel.service';
import { QuickAddBasketV1Service } from './services/quick-add-basket-v1.service';
import { P13nEndpointService } from './services/p13n-endpoint.service';
import { ZoneService } from './services/zone.service';
import { MylistService } from './services/mylist.service';
import { PurchasesEndpointService} from './services/purchases-endpoint.service'
import { ZoneRendererService } from './services/zone-renderer.service';
@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    ABTestService,
    AemService,
    CartService,
    CartV2Service,
    CommonService,
    ConfigService,
    DatalayerService,
    UtilService,
    UserInfoService,
    ProductCouponService,
    OfferDetailService,
    CouponListService,
    ProductUtilService,
    AppConfigService,
    ArService,
    BoxtopService,
    ProductFilterService,
    IntersectionObserverService,
    SortAlV1Service,
    DatasScrollService,
    LoaderService,
    J4uV1Service,
    QuickAddBasketV1Service,
    P13nEndpointService,
    ZoneService,
    ZoneRendererService,
    LoyaltyCarouselService,
    MylistService,
    PurchasesEndpointService,
    {provide: 'EnviormentConfig', useValue: EnviormentConfig}
  ]
})
export class CoreModule {
  static forRoot(configObj): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [CartService, {provide: 'configObj', useValue: configObj}]
    };
  }
 }
